import { useStableAuth } from '@/hooks/useStableAuth';
import { scopedDraftKey, type DraftStorageBase } from '@/lib/scopedDraftStorage';

// RASCUNHOS-NAVEGADOR (I.176): chave do rascunho com empresa + usuário; null enquanto a identidade não está pronta
export function useScopedDraftKey(base: DraftStorageBase): string | null {
  const { userId, companyId } = useStableAuth();
  return scopedDraftKey(base, companyId, userId);
}
